// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"overdueList_wrapper__2ro3m","header":"overdueList_header__3grfX","pagination":"overdueList_pagination__uIfrz"};